export default __webpack_public_path__ + "static/media/Oswald-VariableFont_wght.7aae6336.ttf";